export const SETTINGS_PATH = '/settings'

export const SETTINGS_TABS = {
  ACCOUNT: 'account',
  WALLET: 'wallet',
  TRANSACTIONS: 'transactions',
} as const

export type SettingsTabId = (typeof SETTINGS_TABS)[keyof typeof SETTINGS_TABS]

/** A tab resolved on the server. Embedded tabs carry the external URL their iframe loads. */
export type SettingsTab =
  | { id: typeof SETTINGS_TABS.ACCOUNT }
  | { id: typeof SETTINGS_TABS.WALLET | typeof SETTINGS_TABS.TRANSACTIONS; url: string }

export const DISPLAY_NAME_MAX_LENGTH = 30

/** Bare icon buttons on the Account tab: 44px touch target below md, 36px from md up. */
export const ACCOUNT_ICON_BUTTON_CLASS = 'size-11 p-3 md:size-9 md:p-2'

/** HTC Account page that owns email, password, data rights (DSR) and account deletion. */
export const HTC_ACCOUNT_MANAGE_PATH = '/account'

/** Market pages embedded by the payment tabs, resolved against `NEXT_PUBLIC_MARKET_SERVER`. */
export const MARKET_EMBED_PATHS = {
  [SETTINGS_TABS.WALLET]: '/settings',
  [SETTINGS_TABS.TRANSACTIONS]: '/activity',
} as const
